var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "c-file-input-wrapper", class: { invalid: _vm.error } },
    [
      _vm.displayPreview && _setup.previewMode
        ? _c(
            "div",
            { staticClass: "preview-container mb-2" },
            [
              _c("label", [_vm._v(_vm._s(_vm.previewLabel))]),
              _vm._v(" "),
              _vm._t("preview", null, {
                files: _setup.files,
                removeFile: _setup.removeFile,
              }),
              _vm._v(" "),
              !_setup.slots.preview
                ? _c(
                    "div",
                    { staticClass: "file-preview" },
                    _vm._l(_setup.files, function (file, idx) {
                      return _c(
                        "div",
                        { key: `file-preview-${idx}`, staticClass: "file" },
                        [
                          _c(_setup.CPreview, { attrs: { src: file } }),
                          _vm._v(" "),
                          typeof file != "string" || _setup.allowPreviewRemove
                            ? _c(
                                "div",
                                { staticClass: "remove-overlay" },
                                [
                                  _c(_setup.CButton, {
                                    directives: [
                                      {
                                        name: "tippy",
                                        rawName: "v-tippy",
                                        value: {
                                          placement: "top",
                                          interactive: false,
                                        },
                                        expression:
                                          "{ placement: 'top', interactive: false }",
                                      },
                                    ],
                                    attrs: {
                                      content: "Delete",
                                      size: "sm",
                                      icon: "fa-solid fa-trash",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _setup.removeFile(idx)
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dragAndDrop
        ? _c(
            "div",
            {
              staticClass: "drag-container",
              class: {
                "preview-mode":
                  (_vm.displayPreview || _setup.slots.preview) &&
                  _setup.previewMode,
                disabled: _vm.disabled,
              },
              on: {
                dragover: function ($event) {
                  $event.preventDefault()
                  return _setup.handleDragOver.apply(null, arguments)
                },
                drop: function ($event) {
                  $event.preventDefault()
                  return _setup.handleDrop.apply(null, arguments)
                },
              },
            },
            [
              _c("font-awesome-icon", {
                staticClass: "upload-icon",
                attrs: { icon: "fa-solid fa-cloud-arrow-up" },
              }),
              _vm._v(" "),
              _c(
                "span",
                [
                  _vm._v("\n            Drag&Drop or\n            "),
                  _c(_setup.CButton, {
                    staticClass: "p-0",
                    attrs: {
                      variant: "link",
                      text: "Browse",
                      disabled: _vm.disabled,
                    },
                    on: { click: _setup.openFileUploader },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "d-flex justify-content-between" },
            [
              _vm._t("uploadTrigger", null, null, {
                onFileUpload: _setup.openFileUploader,
                disabled: _vm.disabled,
              }),
              _vm._v(" "),
              !_setup.slots.uploadTrigger
                ? _c(_setup.CButton, {
                    attrs: {
                      text: _setup.btnText,
                      variant: "outline-primary",
                      disabled: _vm.disabled,
                    },
                    on: { click: _setup.openFileUploader },
                  })
                : _vm._e(),
              _vm._v(" "),
              _setup.previewMode
                ? _c(_setup.CButton, {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { placement: "top", interactive: false },
                        expression: "{ placement: 'top', interactive: false }",
                      },
                    ],
                    attrs: { content: "Delete", icon: "fa-solid fa-trash" },
                    on: {
                      click: function ($event) {
                        return _setup.removeFile()
                      },
                    },
                  })
                : _vm._e(),
            ],
            2
          ),
      _vm._v(" "),
      _c("input", {
        ref: "fileInputRef",
        staticClass: "d-none",
        attrs: {
          type: "file",
          accept: _vm.accept,
          multiple: _vm.multiple,
          disabled: _vm.disabled,
        },
        on: { change: _setup.handleFileChange },
      }),
      _vm._v(" "),
      _vm.error
        ? _c(_setup.CError, { attrs: { message: _vm.errorMsg } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }